




import {
  Vue,
  Component,
  Prop,
  Watch,
} from "@/shared/vuepack";
import { useBankAccountHoldStore } from "@/employer/store/bankAccountHold";

  @Component
  export default class AccountHolderHoldsAlert extends Vue {
    bankAccountHoldStore = useBankAccountHoldStore();

    @Prop()
    username: string;

    @Prop()
    partnerId: number;

    mounted () {
      this.load();
    }

    @Watch("username")
    @Watch("partnerId")
    load () {
      this.bankAccountHoldStore.loadHolds({username: this.username, partnerId: this.partnerId});
    }
  }
